import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";
import { brand } from "../config/brand";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  const phoneHref = brand.contact.phone
    ? `tel:${brand.contact.phone.replace(/[^+\d]/g, "")}`
    : null;

  return (
    <footer className="relative z-10 mt-24 border-t border-white/10 bg-night-900">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-20 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.3fr_0.75fr_1fr] lg:gap-16">
          <div className="max-w-sm">
            <Link to="/" className="inline-flex" aria-label="Forpost">
              <Logo size="sm" />
            </Link>
            <p className="mt-6 text-sm leading-7 text-ink-300">
              {t("footer-description")}
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-ink-100">
              {t("footer-navigation")}
            </p>
            <nav className="mt-5 flex flex-col items-start gap-3 text-sm text-ink-300" aria-label={t("footer-navigation")}>
              <Link to="/tracking" className="transition-colors hover:text-signal-400">
                {t("footer-track-shipment")}
              </Link>
              <Link to="/contacts" className="transition-colors hover:text-signal-400">
                {t("header-contacts")}
              </Link>
              <a href={brand.cabinetUrl} target="_blank" rel="noreferrer" className="transition-colors hover:text-signal-400">
                {t("header-cabinet")}
              </a>
            </nav>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-ink-100">
              {t("footer-contact")}
            </p>
            <div className="mt-5 flex flex-col items-start gap-3 text-sm leading-6 text-ink-300">
              {phoneHref && (
                <a href={phoneHref} className="transition-colors hover:text-signal-400">
                  {brand.contact.phone}
                </a>
              )}
              <a href={`mailto:${brand.contact.email}`} className="transition-colors hover:text-signal-400">
                {brand.contact.email}
              </a>
              <span>{t("footer-address")}</span>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-6 text-xs text-ink-400 sm:flex-row sm:items-center sm:justify-between">
          <span>© {currentYear} {t("footer-company")}</span>
          <a
            href="https://vinci.kz"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1.5 font-semibold transition-colors hover:text-ink-100"
          >
            {t("footer-made-by")} <strong className="tracking-[0.12em] text-signal-500">VINCI</strong>
            <span aria-hidden="true">↗</span>
          </a>
          <Link to="/privacyAgreement" className="transition-colors hover:text-ink-100">
            {t("footer-privacy")}
          </Link>
        </div>
      </div>
    </footer>
  );
}
